module.exports = __webpack_public_path__ + "static/media/bankNavLogoNew.19c9cbc7.svg";